<template>
<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-white navbar-light d-flex justify-content-between">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <h1 :class="{'cabecalhoTituloGestaoConta': opcaoMenuGestaoConta }" class="titulos cabecalhoTitulo">{{tituloPagina}}</h1>
  </ul>
  <ol  class="breadcrumb float-sm-right" style="background-color: #fff; margin-top: 2%">
    <li class="breadcrumb-item titulos"></li>
  </ol>
  <div style="margin: 0 auto;">
    <a v-if="opcaoMenuSistemaJuridico" href="https://www.officeadv.com.br" target="_blank">
      <img :src="obterLogo" alt="Office.ADV" width="150" class="brand-image" />
    </a>
  </div>
  <!-- Right navbar links -->
  <ul class="navbar-nav my-auto">
    <li class="nav-item" v-if="opcaoMenuGestaoConta">
      <CarrinhoCompras/>
    </li>
    <li class="nav-item dropdown">
      <a class="nav-link" style="inline-size: max-content" data-toggle="dropdown" href="#">
        <b-img v-if="usuarioTemFoto" rounded="circle" width="32" height="32" :src="'data:image/png;base64,' + this.codigoFotoUsuario" :alt="`Foto do usuário ${obterPrimeiroNomeDoUsuario}`" :title="obterPrimeiroNomeDoUsuario"/>
        <b-img v-else rounded="circle" width="32" height="32" :src="require('@/assets/img/usuario-sem-foto.png')" alt="Usuário sem foto"/>
        <span class="d-none d-sm-inline">{{obterPrimeiroNomeDoUsuario}}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
        <div class="dropdown-divider"></div>
        <router-link v-if="opcaoMenuSistemaJuridico" class="dropdown-item" to="/minha-conta">
          <i class="fas fa-user mr-2"></i> Minha Conta
        </router-link>
        <router-link v-if="opcaoMenuSistemaJuridico" class="dropdown-item" to="/configuracoes">
          <i class="fas fa-cog mr-2"></i> Configurações
        </router-link>
        <div v-if="opcaoMenuSistemaJuridico" class="dropdown-divider"></div>
        <a v-if="opcaoMenuSistemaJuridico" href="#" class="dropdown-item" @click="logout">
          <i class="fas fa-sign-out-alt mr-2"></i> Sair
        </a>
        <a v-if="opcaoMenuGestaoConta" href="#" class="dropdown-item" @click="logoutGestaoConta">
          <i class="fas fa-sign-out-alt mr-2"></i> Sair
        </a>
      </div>
    </li>
  </ul>
</nav>
<!-- /.navbar -->
</template>

<script>
import util from '@/util'
import { obterImagem } from '@/util/imagem'
import usuarioUtil from '@/util/usuarioUtil'
import mensagens from '@/util/mensagens'
import { mapActions, mapGetters, mapState } from 'vuex'
import CarrinhoCompras from '@/components/global/CarrinhoCompras/CarrinhoCompras.vue'
import { encerrarChat, atualizarChat } from '@/components/global/SuporteOnline'

export default {
  name: 'Cabecalho',
  props: {
    tituloPagina: [String]
  },
  components: {
    CarrinhoCompras
  },
  computed: {
    ...mapState('auth', ['nomeUsuarioLogado', 'codigoFotoUsuario', 'emailUsuario', 'idUsuarioLogado', 'dataCriacaoUsuarioLogado', 'suporteOnlineHabilitado', 'idEmpresa', 'escritorio']),
    ...mapGetters('auth', ['opcaoMenuSistemaJuridico', 'opcaoMenuGestaoConta']),
    usuarioTemFoto () {
      if (!this.opcaoMenuSistemaJuridico) {
        return false
      }
      return usuarioUtil.usuarioTemFoto(this.codigoFotoUsuario)
    },
    obterPrimeiroNomeDoUsuario () {
      return usuarioUtil.obterPrimeiroNomeUsuario(this.nomeUsuarioLogado)
    },
    obterLogo () {
      return obterImagem('logo-office.png')
    }
  },
  async mounted () {
    if (this.opcaoMenuGestaoConta) {
      await atualizarChat(this, this.nomeUsuarioLogado, this.emailUsuario)
      return
    }
    if (this.suporteOnlineHabilitado) {
      await atualizarChat(this, this.nomeUsuarioLogado, this.emailUsuario, this.dataCriacaoUsuarioLogado, this.idUsuarioLogado, this.idEmpresa, this.escritorio)
    } else {
      console.log('Suporte Online não habilitado')
      await encerrarChat(this)
    }
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),

    async logout () {
      try {
        await this.axios.post('/logout')
        await encerrarChat(this)
        this.ActionSignOut()
        this.$router.push({ name: 'login' })
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    },

    async logoutGestaoConta () {
      try {
        await this.axios.post('/manager/conta/logout')
        await encerrarChat(this)
        this.ActionSignOut()
        this.$router.push({ name: 'loginLite' })
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    }
  }
}
</script>

<style scoped>
@import "./scss/Cabecalho.scss";
</style>
